import React from 'react'
import { Link } from 'react-router-dom'
import classNames from 'classnames'
import scrollToTop from '../scrollToTop'

const socials = [
  { name: 'linkedin', link: 'https://www.linkedin.com/company/playversus/' },
  { name: 'twitter', link: 'https://twitter.com/playvs?lang=en' },
  { name: 'instagram', link: 'https://www.instagram.com/playvscom/?hl=en' },
  { name: 'facebook', link: 'https://www.facebook.com/playvscom/' }
]

const Footer = props => (
  <footer>
    <div className="container">
      <div className="row--wider">
        <div className="column--third">
          <a href="/" className="logo">
            Playvs
          </a>
          <p>We're building the infrastructure and official platform for high school esports.</p>
        </div>
        <div>
          <div className="h7">Learn more</div>
          <ul>
            <li>
              <Link to="/games" onClick={scrollToTop}>
                Featured Games
              </Link>
            </li>
            <li>
              <Link to="/faq" onClick={scrollToTop}>
                FAQ
              </Link>
            </li>
            <li>
              <Link to="/scholarships" onClick={scrollToTop}>
                Scholarships
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="h7">Company</div>
          <ul>
            <li>
              <Link to="/about" onClick={scrollToTop}>
                About
              </Link>
            </li>
            <li>
              <Link to="/careers" onClick={scrollToTop}>
                Careers
              </Link>
            </li>
            <li>
              <Link to="/press" onClick={scrollToTop}>
                Press
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <div className="h7">Get Started</div>
          <ul>
            <li>
              <a href="https://app.playvs.com/sign-up/" target="_blank">
                Sign up
              </a>
            </li>
            <li>
              <a href="mailto:hello@playvs.com">Email us</a>
            </li>
            <li>
              <Link to="/pricing" onClick={scrollToTop}>
                Pricing
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="row--wider">
        <div className="second">
          <span>&copy; Play Versus, Inc.</span>
          <ul className="horizontal-menu">
            <li>
              <Link to="/terms" onClick={scrollToTop}>
                Terms
              </Link>
            </li>
            <li>
              <Link to="/privacy" onClick={scrollToTop}>
                Privacy
              </Link>
            </li>
          </ul>
        </div>
        <div className="socials first">
          {socials.map(s => {
            return (
              <a href={s.link} target="_blank" key={s.name}>
                <div
                  className={classNames({
                    'social-icon': true,
                    [s.name]: true
                  })}
                />
              </a>
            )
          })}
        </div>
      </div>
    </div>
  </footer>
)

export default Footer



// WEBPACK FOOTER //
// ./src/common/ui/components/footer.js